import React, {Component} from 'react';

import ResultSearchInfo from './ResultSearchInfo';
import ResultSearchContent from './ResultSearchContent';

class ResultSearch extends Component {
    render() {
        return (
            <section className="rezult_serch clearfix">
                <ResultSearchInfo/>
                <ResultSearchContent/>
            </section>
        )
    }
}

export default ResultSearch;


// WEBPACK FOOTER //
// ./src/components/Search/ResultSearch.js